/**
 * Samouczek 'Cenniki'. Ksztalt danych: patrz frontend/src/pomoc/samouczki/KONTRAKT.md
 */
const OBRAZ = (plik, opis) => ({ plik, opis });

// Naglowki dzialow. Przy pietnastu krokach z rzedu czytelnik gubi sie po trzecim -
// podzial na cztery dzialy daje mu punkt zaczepienia i pozwala wrocic do wlasciwego
// miejsca po przerwie.
const DZIALY = {
  A: { tytul: 'Uzupełnianie cen specjalnych', opis: 'Podstawa. Jak znaleźć produkty bez ceny i nadać im cenę obowiązującą w Twoim sklepie.' },
  B: { tytul: 'Szybsze sposoby na znalezienie produktów', opis: 'Zamiast przewijać listę: zeskanuj produkty z półki albo wyświetl tylko te z konkretnej faktury.' },
  C: { tytul: 'Kilka produktów naraz', opis: 'Ten sam produkt w kilku smakach ma zwykle tę samą cenę. Nie klikaj po kolei.' },
  D: { tytul: 'Drukowanie cenówek', opis: 'Od zaznaczenia produktów do gotowej etykiety na półkę.' },
};

const CENNIKI = {
    id: 'cenniki',
    dzialy: DZIALY,
    tytul: 'Cenniki — uzupełnianie cen specjalnych i druk cenówek',
    dlaKogo: 'Kasjerzy, kierownicy',
    czas: '5 minut',
    pdf: '/instrukcje/cenniki-ceny-specjalne.pdf',
    wstep: 'Cena specjalna to cena obowiązująca w Twoim sklepie. Dopóki produkt jej nie ma, '
      + 'sprzedaje się po cenie domyślnej z centrali — a ta nie zawsze jest tą, którą chcemy mieć na półce.',
    kroki: [
      {
        n: 1,
        dzial: 'A',
        tytul: 'Znajdź czerwony boks',
        tresc: 'Po wejściu w zakładkę Ceny / Cenówki u góry widzisz cztery liczby. Ta w czerwonej ramce — '
          + '„Ceny specjalne do uzupełnienia" — mówi, ile produktów w Twoim sklepie nie ma jeszcze własnej ceny. '
          + 'Jeśli pokazuje zero, nie masz nic do zrobienia.',
        obraz: OBRAZ('/instrukcje/sam-1-boks.jpg', 'Boks z liczbą produktów do uzupełnienia'),
      },
      {
        n: 2,
        dzial: 'A',
        tytul: 'Kliknij w boks — lista sama się zawęzi',
        tresc: 'Jedno kliknięcie ustawia filtr. Na liście zostają wyłącznie produkty bez ceny specjalnej. '
          + 'W kolumnie STATUS wszystkie wiersze mają wtedy szarą etykietę „Dom.". '
          + 'Kliknięcie w ten sam boks jeszcze raz wyłącza filtr.',
        obraz: OBRAZ('/instrukcje/sam-2-filtr.jpg', 'Lista zawężona do produktów bez ceny specjalnej'),
      },
      {
        n: 3,
        dzial: 'A',
        tytul: 'Znajdź kolumnę CENA SPEC.',
        tresc: 'Kolumna CENA SPEC. znajduje się między CENA DOM. a MARŻA. '
          + 'Przy produktach bez ceny specjalnej jest pusta.',
        obraz: OBRAZ('/instrukcje/sam-3-kolumna.jpg', 'Kolumna CENA SPEC. w tabeli'),
      },
      {
        n: 4,
        dzial: 'A',
        tytul: 'Kliknij dwa razy i wpisz cenę',
        tresc: 'Dwuklik w komórkę zamienia ją w pole do wpisania. Pole podpowiada aktualną cenę domyślną. '
          + 'Wpisujesz cenę BRUTTO — tę, którą klient płaci przy kasie. Netto system przeliczy sam.',
        obraz: OBRAZ('/instrukcje/sam-4-edycja.jpg', 'Pole edycji ceny po dwukliku'),
      },
      {
        n: 5,
        dzial: 'A',
        tytul: 'Zatwierdź Enterem',
        tresc: 'Enter zapisuje, Escape anuluje, kliknięcie obok też zapisuje. '
          + 'Status zmienia się z „Dom." na „Spec.", a licznik w czerwonym boksie maleje o jeden. '
          + 'Pomyłkę poprawisz tak samo — dwuklik i nowa cena.',
        obraz: OBRAZ('/instrukcje/sam-5-wpisana.jpg', 'Wpisana cena przed zatwierdzeniem'),
      },
      {
        n: 6,
        dzial: 'B',
        tytul: 'Skanuj produkty z półki',
        tresc: 'Bierzesz kilka opakowań z półki i skanujesz je po kolei. Kliknij w pole „Skanuj kod" '
          + 'i przejedź czytnikiem po każdym produkcie — nie musisz nic klikać między jednym a drugim.',
        obraz: OBRAZ('/instrukcje/skan-1-pole.jpg', 'Pole skanowania kodów'),
      },
      {
        n: 7,
        dzial: 'B',
        tytul: 'Na liście zostają tylko zeskanowane',
        tresc: 'Nad tabelą pojawia się niebieski pasek „Zeskanowane produkty" z licznikiem i listą kodów. '
          + 'W tabeli zostają wyłącznie te produkty, które zeskanowałeś — i są od razu zaznaczone. '
          + 'Stąd robisz wszystko to samo co zwykle: dwuklik w cenę albo od razu „Do bufora" i wydruk. '
          + 'Pomyłka? Każdy kod ma krzyżyk, a przycisk „Wyczyść" kasuje całą listę.',
        obraz: OBRAZ('/instrukcje/skan-2-lista.jpg', 'Lista zawężona do zeskanowanych produktów'),
      },
      {
        n: 8,
        dzial: 'B',
        tytul: 'Albo wyświetl produkty z faktury',
        tresc: 'Przyszła dostawa i chcesz nadać ceny wszystkiemu, co przyjechało? Rozwiń listę po lewej '
          + 'stronie — domyślnie pisze na niej „Wszystkie produkty" — a znajdziesz tam wszystkie '
          + 'wprowadzone faktury, od najnowszej.',
        obraz: OBRAZ('/instrukcje/faktura-1-lista.jpg', 'Lista faktur do wyboru'),
      },
      {
        n: 9,
        dzial: 'B',
        tytul: 'Wybierz fakturę',
        tresc: 'Na liście zostają wyłącznie produkty z tej faktury. Nad tabelą system pisze, ile ich jest — '
          + 'na przykład „16 produktów z 16 pozycji faktury". Jeśli te liczby się różnią, część pozycji '
          + 'nie ma jeszcze kartoteki w systemie. To najszybsza droga po dostawie: wprowadzasz fakturę, '
          + 'wybierasz ją tutaj, uzupełniasz ceny i drukujesz cenówki.',
        obraz: OBRAZ('/instrukcje/faktura-2-wybrana.jpg', 'Lista zawężona do produktów z faktury'),
      },
      {
        n: 10,
        dzial: 'C',
        tytul: 'Zaznacz produkty o wspólnej cenie',
        tresc: 'Ten sam produkt w pięciu smakach zwykle ma tę samą cenę. Nie ma sensu klikać pięć razy. '
          + 'Znajdź produkty wyszukiwarką (np. wpisz COLLAROSE), zaznacz ptaszkami te, które mają mieć '
          + 'wspólną cenę, i kliknij „Edytuj ceny" na pasku u góry.',
        obraz: OBRAZ('/instrukcje/masowa-1-zaznacz.jpg', 'Zaznaczone smaki tego samego produktu'),
      },
      {
        n: 11,
        dzial: 'C',
        tytul: 'Sposób pierwszy: po marży',
        tresc: 'W oknie „Zmiana cen" wybierz Marża (%) i wpisz, ile chcesz zarabiać — na przykład 35. '
          + 'System sam wyliczy cenę dla każdego produktu osobno, na podstawie ceny zakupu. '
          + 'To właściwy sposób, gdy produkty mają różne ceny zakupu: każdy dostanie swoją cenę, '
          + 'ale zarobek na każdym będzie taki sam. Zaznacz „Zaokrąglij do cen psychologicznych", '
          + 'a system zamieni 12,50 zł na 12,99 zł.',
        obraz: OBRAZ('/instrukcje/masowa-3-marza.jpg', 'Zmiana cen według docelowej marży'),
      },
      {
        n: 12,
        dzial: 'C',
        tytul: 'Sposób drugi: po cenie',
        tresc: 'Wybierz „Ustaw cenę" i wpisz jedną kwotę brutto — wszystkie zaznaczone produkty dostaną '
          + 'dokładnie tę samą cenę. Tego używaj, gdy smaki mają stać na półce po równo. '
          + 'Są jeszcze dwa tryby: Procent (%) podnosi lub obniża obecne ceny o zadany procent '
          + '(przydaje się przy podwyżkach od dostawcy), a Zmień kwotę dodaje lub odejmuje złotówki. '
          + 'Zanim klikniesz „Zastosuj zmiany", sprawdź liczbę zaznaczonych produktów u góry okna.',
        obraz: OBRAZ('/instrukcje/masowa-4-cena.jpg', 'Zmiana cen przez ustawienie jednej ceny'),
      },
      {
        n: 13,
        dzial: 'D',
        tytul: 'Zaznacz produkty do druku',
        tresc: 'Gdy ceny są uzupełnione, czas na cenówki. Zaznacz produkty ptaszkami po lewej stronie — '
          + 'jeden albo kilkadziesiąt naraz. Po zaznaczeniu u góry pojawia się pasek z przyciskami.',
        obraz: OBRAZ('/instrukcje/druk-1-zaznacz.jpg', 'Zaznaczanie produktów do druku'),
      },
      {
        n: 14,
        dzial: 'D',
        tytul: 'Kliknij PODGLĄD',
        tresc: 'To jedyna droga do wydruku — i dobrze, bo zobaczysz, jak cenówki naprawdę wyjdą, '
          + 'zanim zużyjesz papier.',
        obraz: OBRAZ('/instrukcje/druk-5-podglad-przycisk.jpg', 'Przycisk Podgląd na pasku'),
      },
      {
        n: 15,
        dzial: 'D',
        tytul: 'Sprawdź i drukuj',
        tresc: 'W oknie podglądu ustawisz, co ma być na cenówce (producent, nazwa, waga, cena), '
          + 'wielkość liter oraz powielanie — ile sztuk tej samej cenówki wydrukować. '
          + 'Na końcu Drukuj otwiera zwykłe okno drukowania przeglądarki. '
          + 'Jeśli zbierasz cenówki przez cały dzień, użyj przycisku „Do bufora" i wydrukuj wszystko na raz.',
        obraz: OBRAZ('/instrukcje/druk-7-drukuj.jpg', 'Okno podglądu cenówek z przyciskiem Drukuj'),
      },
    ],
    uwagi: [
      'Sprawdź, na którym sklepie jesteś — nazwa lokalizacji jest w boksie po prawej. Cena specjalna dotyczy tylko tego sklepu.',
      'Patrz na marżę. Jeśli po zapisaniu zrobi się bardzo niska, prawdopodobnie wpisałeś cenę netto zamiast brutto.',
      'Nie zgaduj. Jeśli nie wiesz, jaka cena ma być — zostaw i zapytaj kierownika. Pusta cena jest lepsza niż zła.',
      'Drukuj po uzupełnieniu, nie przed. Cenówka bierze cenę z systemu w chwili druku.',
    ],
};

export default CENNIKI;
